import { OffHireTypeEnum } from '../../enum/off-hire-type.enum';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class CreateOffHireCommand {
  OffHireId: string;
  SiteId: string;
  CustomerId: string;
  OffHireType: OffHireTypeEnum;
  Scaffolds: string[];
  OwnerId: string;
  CommandVersion: string;
  SourceApp: string;
  SourceAppVersion: string;
}


